
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/doubts-and-solutions/doubt/[doubtUID]",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/doubts-and-solutions/doubt/[doubtUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/doubts-and-solutions/doubt/[doubtUID]"])
      });
    }
  